import echarts from '@/config/echarts/index.js'
import moment from 'moment'
export function getHourForecastOption () {
  const data = []
  return {
    color: ['#58dfd9', '#5DF5EC'],
    legend: {
      show: true,
      top: 0,
      itemWidth: 14,
      itemHeight: 9,
      itemGap: 20,
      icon: 'circle',
      textStyle: {
        color: '#FFF',
        fontSize: '0.8rem'
      }
    },
    grid: {
      // left: 40,
      right: 10,
      top: 30,
      bottom: 20
    },
    tooltip: {
      trigger: 'axis',
      textStyle: {
        fontStyle: '0.63vw' // 文字字体的风格（'normal'，无样式；'italic'，斜体；'oblique'，倾斜字体）
      },
      formatter: function (params) {
        console.log('params', params)
        var result = ''
        var dotHtml = '<span style="display:inline-block;margin-right:0.26vw;border-radius:0.52vw;width:0.52vw;height:0.52vw;background-color:rgba(88, 223, 217, 1)"></span>' // 定义第一个数据前的圆点颜色
        if (params[0].data !== '--') {
          result += params[0].axisValue + '</br>' + dotHtml + ' 雨量 ' + params[0].data + 'mm'
        }
        return result
      }
    },
    xAxis: {
      data: data,
      axisTick: { length: 5 },
      axisLine: {
        onZero: false
      },
      axisLabel: {
        color: '#FFF',
        fontSize: '0.9rem',
        // formatter: function (value) {
        //   return moment(Number(value)).format('HH')
        // }
      }
    },
    yAxis: {
      type: 'value',
      name: '',
      nameLocation: 'end',
      nameTextStyle: {
        color: '#FFF',
        fontSize: '0.9rem',
        align: 'left',
        padding: [0, 0, 0, -30]
      },
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dashed',
          color: 'rgba(255, 255, 255, 0.3)',
        }
      },
      axisLabel: {
        color: '#FFF',
        fontSize: '0.9rem'
      }
    },
    series: [
      {
        name: '雨量',
        type: 'line',
        smooth: true,
        symbol: 'circle',
        symbolSize: 0,
        lineStyle: {
          width: 2,
          color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
            {
              offset: 1,
              color: 'rgba(88, 223, 217, 1)'
            },
            {
              offset: 0.5,
              color: 'rgba(88, 223, 217, 0.5)'
            },
            {
              offset: 0,
              color: 'rgba(255, 255, 255, 0)'
            }
          ])
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
            {
              offset: 1,
              color: 'rgba(88, 223, 217, 1)'
            },
            {
              offset: 0.5,
              color: 'rgba(88, 223, 217, 0.5)'
            },
            {
              offset: 0,
              color: 'rgba(255, 255, 255, 0)'
            }
          ])
        },
        data: [], // 你的数据

      }
      // {
      //   name: '雨量',
      //   type: 'bar',
      //   barWidth: '4rem',
      //   width: '5px',
      //   data: [],
      //   label: {
      //     show: false,
      //     position: 'top',
      //     fontSize: '0.75rem',
      //     color: '#FFF'
      //   },
      //   color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
      //     {
      //       offset: 1,
      //       color: 'rgba(88, 223, 217, 1)'
      //     },
      //     {
      //       offset: 0.5,
      //       color: 'rgba(88, 223, 217, 0.5)'
      //     },
      //     {
      //       offset: 0,
      //       color: 'rgba(255, 255, 255, 0)'
      //     }
      //   ]),
      //   itemStyle: {
      //     normal: {
      //       barBorderRadius: [2, 2, 0, 0]
      //     }
      //   }
      // },

    ]
  }
}
